import tryParseDate from "~/kernel/dateTime/tryParseDate";
import transform from "~/kernel/objects/transform";
import type SerializeType from "~/kernel/server/SerializeType";
import type { Service } from "../models/Service";

export default function deserializeService(
  service: SerializeType<Service>,
): Service {
  return transform(service, {
    deletedAt: (deletedAt) => tryParseDate(deletedAt),
  });
}
